import { render, staticRenderFns } from "./userOrder.vue?vue&type=template&id=f477e8ec&scoped=true"
import script from "./userOrder.vue?vue&type=script&lang=js"
export * from "./userOrder.vue?vue&type=script&lang=js"
import style0 from "./userOrder.vue?vue&type=style&index=0&id=f477e8ec&prod&lang=scss"
import style1 from "./userOrder.vue?vue&type=style&index=1&id=f477e8ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f477e8ec",
  null
  
)

export default component.exports